import { Link } from "react-router-dom";
import { Play, FileText, Images, FileUp } from "lucide-react";
import { mediaUrl, thumbUrl } from "@/lib/api";

export default function ItemCard({ item, categorySlug, categoryName }) {
  const cover = item.media?.find((m) => m.media_type === "image") || item.media?.[0];
  const count = item.media?.length || 0;
  const coverType = cover?.media_type;

  return (
    <Link
      to={`/portfolio/${categorySlug}/${item.slug}`}
      data-testid={`work-card-${item.slug}`}
      className="group block break-inside-avoid mb-6 bg-surface-white border border-charcoal-900/10 rounded-2xl overflow-hidden hover:shadow-xl hover:border-copper-600/30 transition-[box-shadow,border-color] duration-300"
    >
      <div className="relative overflow-hidden bg-surface-muted aspect-[4/3]">
        {coverType === "image" ? (
          <img
            src={thumbUrl(cover)}
            alt={cover.alt_text || item.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        ) : (
          <div
            className="w-full h-full flex items-center justify-center group-hover:scale-[1.03] transition-transform duration-500"
            style={{ backgroundImage: "repeating-linear-gradient(135deg, rgba(18,19,22,0.035) 0 1px, transparent 1px 14px)" }}
          >
            <span className="w-14 h-14 rounded-full bg-parchment border border-charcoal-900/10 flex items-center justify-center text-copper-600">
              {coverType === "video" ? <Play className="w-6 h-6" /> : coverType === "pdf" ? <FileText className="w-6 h-6" /> : <FileUp className="w-6 h-6" />}
            </span>
          </div>
        )}
        <div className="absolute top-3 right-3 flex gap-1.5">
          {count > 1 && (
            <span className="inline-flex items-center gap-1 font-mono text-[10px] tracking-wide bg-charcoal-900/80 text-parchment rounded-full px-2.5 py-1 backdrop-blur-sm">
              <Images className="w-3 h-3" /> {count}
            </span>
          )}
          {coverType === "video" && (
            <span className="inline-flex items-center gap-1 font-mono text-[10px] tracking-wide bg-copper-600/90 text-parchment rounded-full px-2.5 py-1">
              <Play className="w-3 h-3" /> VIDEO
            </span>
          )}
          {coverType === "pdf" && (
            <span className="inline-flex items-center gap-1 font-mono text-[10px] tracking-wide bg-copper-600/90 text-parchment rounded-full px-2.5 py-1">
              <FileText className="w-3 h-3" /> PDF
            </span>
          )}
        </div>
      </div>
      <div className="p-5">
        <p className="font-mono text-[10px] tracking-[0.18em] uppercase text-copper-600">
          {categoryName}
          {item.year ? ` · ${item.year}` : ""}
        </p>
        <h3 className="mt-1.5 text-base font-semibold text-charcoal-900 leading-snug group-hover:text-copper-600 transition-colors">
          {item.title}
        </h3>
      </div>
    </Link>
  );
}
